<template>
    <span>
        <img
                class="ms-storage-image"
                v-lazy="imageSrc"
                :width="pxWidth ? pxWidth : null"
                :height="pxHeight ? pxHeight : null"
                :alt="alt === null ? file.fileTitle : alt"
        >
        <span class="ms-storage-image-error">
            <slot name="error" />
        </span>
    </span>
</template>
<script>
    import FileAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource';
    import {mapGetters} from 'vuex';

    export default {
        name: 'LazyStorageImage',
        props: {
            file: {
                type: FileAppResource,
                required: true,
            },
            alt: {
                type: String,
                required: false,
                default: null,
            },
            width: {
                type: [Number, String],
                required: false,
            },
            height: {
                type: [Number, String],
                required: false,
            },
            position: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                pxWidth: null,
                pxHeight: null,
            };
        },
        computed: {
            ...mapGetters({
                refreshToken: 'refreshToken',
            }),
            imageSrc() {
                let src;
                if (this.file.publicUrl) {
                    src = this.file.publicUrl;
                } else {
                    src = window.env.MILESTONES_API_HOST + '/file/' + this.file.uuid + '?token=' + this.refreshToken;
                }
                if (this.pxWidth) {
                    src = src + '&w=' + this.pxWidth;
                }
                if (this.pxHeight) {
                    src = src + '&h=' + this.pxHeight;
                }
                if (this.position) {
                    src = src + '&p=' + this.position;
                }
                return src;
            },
        },
        methods: {
            pxDimmensions() {
                if (this.width) {
                    const width = this.convertValueToPixels(this.width);
                    if (!isNaN(width)) {
                        this.pxWidth = width;
                    } else {
                        this.pxWidth = null;
                    }
                }
                if (this.height) {
                    const height = this.convertValueToPixels(this.height);
                    if (!isNaN(height)) {
                        this.pxHeight = height;
                    } else {
                        this.pxHeight = null;
                    }
                }
            },
        },
        beforeMount() {
            this.pxDimmensions();
        },
        watch: {
            width(to, from) {
                this.pxDimmensions();
            },
            height(to, from) {
                this.pxDimmensions();
            },
        },
    };
</script>
<style scoped>
    .ms-storage-image:not([lazy=error]) + .ms-storage-image-error {
        display: none;
    }

    .ms-storage-image[lazy=error] {
        display: none;
    }
</style>
